import React, { useState } from "react";
import Body from "./Body";

const Dashboard = () => {
  const [classesFilter, setClassesFilter] = useState("");
  const [genderWaysFilter, setGenderWaysFilter] = useState("");
  const [overViewCardData, setOverViewCardData] = useState([
    {
      title: "Students",
      presentCount: "1200",
      cardType: "regular",
      bgColor: "#E8F0FF", // Light blue
      icon: "user", // Optional: add icon name if you use one
    },
    {
      title: "Teachers",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#FFE6E6", // Light red/pink
      icon: "users",
    },
    {
      title: "Today's Events",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#E3FFE9", // Light green
      icon: "calendar-check",
    },
    {
      title: "Rest of the books",
      presentCount: "105",
      cardType: "regular",
      bgColor: "#EFE7E5", // Light brown/grey
      icon: "book",
    },
  ]);

  const [absenteesData, setAbsenteesData] = useState([
    {
      id: "1",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      name: "Aarav Sharma",
      date: "2025-06-21",
      class: "Class 4",
    },
    {
      id: "2",
      image: "https://randomuser.me/api/portraits/women/21.jpg",
      name: "Diya Patel",
      date: "2025-06-20",
      class: "Class 9",
    },
    {
      id: "3",
      image: "https://randomuser.me/api/portraits/men/31.jpg",
      name: "Rohan Verma",
      date: "2025-06-19",
      class: "Class 6",
    },
    {
      id: "4",
      image: "https://randomuser.me/api/portraits/women/41.jpg",
      name: "Ananya Reddy",
      date: "2025-06-20",
      class: "Class 8",
    },
    {
      id: "5",
      image: "https://randomuser.me/api/portraits/men/51.jpg",
      name: "Ishaan Deshmukh",
      date: "2025-06-18",
      class: "Class 5",
    },
    {
      id: "6",
      image: "https://randomuser.me/api/portraits/women/61.jpg",
      name: "Sneha Nair",
      date: "2025-06-20",
      class: "Class 7",
    },
    {
      id: "7",
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      name: "Karthik Rao",
      date: "2025-06-17",
      class: "Class 6",
    },
    {
      id: "8",
      image: "https://randomuser.me/api/portraits/women/81.jpg",
      name: "Meera Joshi",
      date: "2025-06-19",
      class: "Class 5",
    },
    {
      id: "9",
      image: "https://randomuser.me/api/portraits/men/91.jpg",
      name: "Yash Mehta",
      date: "2025-06-20",
      class: "Class 4",
    },
    {
      id: "10",
      image: "https://randomuser.me/api/portraits/women/15.jpg",
      name: "Ritika Singh",
      date: "2025-06-18",
      class: "Class 9",
    },
    {
      id: "11",
      image: "https://randomuser.me/api/portraits/men/25.jpg",
      name: "Arjun Kapoor",
      date: "2025-06-19",
      class: "Class 10",
    },
    {
      id: "12",
      image: "https://randomuser.me/api/portraits/women/35.jpg",
      name: "Priya Malhotra",
      date: "2025-06-20",
      class: "Class 6",
    },
    {
      id: "13",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      name: "Vivaan Bansal",
      date: "2025-06-20",
      class: "Class 5",
    },
    {
      id: "14",
      image: "https://randomuser.me/api/portraits/women/55.jpg",
      name: "Sanya Iyer",
      date: "2025-06-18",
      class: "Class 7",
    },
    {
      id: "15",
      image: "https://randomuser.me/api/portraits/men/65.jpg",
      name: "Devansh Choudhary",
      date: "2025-06-17",
      class: "Class 8",
    },
  ]);

  const [onleaveData, setOnleaveData] = useState([
    {
      id: "1",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      name: "Rajesh Kumar",
      date: "2025-06-20",
      designation: "Teacher",
    },
    {
      id: "2",
      image: "https://randomuser.me/api/portraits/women/22.jpg",
      name: "Pooja Sharma",
      date: "2025-06-21",
      designation: "Class teacher",
    },
    {
      id: "3",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      name: "Amitabh Sinha",
      date: "2025-06-18",
      designation: "Staff",
    },
    {
      id: "4",
      image: "https://randomuser.me/api/portraits/women/42.jpg",
      name: "Neha Joshi",
      date: "2025-06-19",
      designation: "Non-teaching staff",
    },
    {
      id: "5",
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      name: "Ravi Verma",
      date: "2025-06-20",
      designation: "Teacher",
    },
    {
      id: "6",
      image: "https://randomuser.me/api/portraits/women/62.jpg",
      name: "Sneha Reddy",
      date: "2025-06-20",
      designation: "Class teacher",
    },
    {
      id: "7",
      image: "https://randomuser.me/api/portraits/men/72.jpg",
      name: "Karan Iyer",
      date: "2025-06-19",
      designation: "Staff",
    },
    {
      id: "8",
      image: "https://randomuser.me/api/portraits/women/82.jpg",
      name: "Simran Desai",
      date: "2025-06-18",
      designation: "Non-teaching staff",
    },
    {
      id: "9",
      image: "https://randomuser.me/api/portraits/men/92.jpg",
      name: "Dev Mishra",
      date: "2025-06-21",
      designation: "Teacher",
    },
    {
      id: "10",
      image: "https://randomuser.me/api/portraits/women/16.jpg",
      name: "Kritika Bansal",
      date: "2025-06-17",
      designation: "Class teacher",
    },
  ]);

  const [attendanceData, setAttendanceData] = useState([
    { date: "Aug 1", blueLine: 420, redLine: 290 },
    { date: "Aug 2", blueLine: 530, redLine: 310 },
    { date: "Aug 3", blueLine: 810, redLine: 600 },
    { date: "Aug 4", blueLine: 840, redLine: 550 },
    { date: "Aug 5", blueLine: 580, redLine: 650 },
    { date: "Aug 6", blueLine: 460, redLine: 700 },
    { date: "Aug 7", blueLine: 410, redLine: 280 },
  ]);

  const [lineChartFilter, setLineChartFilter] = useState("");

  const [classWiseAttendanceData, setClassWiseAttendanceData] = useState([
    {
      id: "1",
      class: "Class 10",
      count: 12,
      percentage: 28.6,
      color: "#6BD6C6",
    },
    {
      id: "2",
      class: "Class 9",
      count: 22,
      percentage: 42.9,
      color: "#8CB5FC",
    },
    {
      id: "3",
      class: "Class 8",
      count: 12,
      percentage: 28.6,
      color: "#B2A5F7",
    },
    {
      id: "4",
      class: "Class 7",
      count: 12,
      percentage: 28.6,
      color: "#F4A9C2",
    },
    { id: "5", class: "Class 6", count: 7, percentage: 14.3, color: "#F7C77E" },
    { id: "6", class: "Class 5", count: 7, percentage: 14.3, color: "#FAE17E" },
  ]);
const [bestPerformers, setBestPerformers] = useState([
  {
    id: "1",
    name: "Toufik Alam",
    studentId: "SM0523019",
    class: "5/A",
    points: 10,
    image: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    id: "2",
    name: "Mustak Ahamed",
    studentId: "SM0721011",
    class: "6/B",
    points: 3,
    image: "https://randomuser.me/api/portraits/men/42.jpg",
  },
  {
    id: "3",
    name: "Anisur Islam",
    studentId: "SM0824109",
    class: "7/C",
    points: 32,
    image: "https://randomuser.me/api/portraits/men/43.jpg",
  },
  {
    id: "4",
    name: "Rohit Khan",
    studentId: "SM1223099",
    class: "8/D",
    points: 1,
    image: "https://randomuser.me/api/portraits/men/44.jpg",
  },
  {
    id: "5",
    name: "Sana Fatima",
    studentId: "SM0623045",
    class: "9/A",
    points: 14,
    image: "https://randomuser.me/api/portraits/women/41.jpg",
  },
  {
    id: "6",
    name: "Ayesha Siddiqui",
    studentId: "SM0321123",
    class: "10/B",
    points: 20,
    image: "https://randomuser.me/api/portraits/women/42.jpg",
  },
  {
    id: "7",
    name: "Mohammed Rehan",
    studentId: "SM0423114",
    class: "11/C",
    points: 28,
    image: "https://randomuser.me/api/portraits/men/45.jpg",
  },
  {
    id: "8",
    name: "Priya Sharma",
    studentId: "SM0132098",
    class: "12/D",
    points: 5,
    image: "https://randomuser.me/api/portraits/women/43.jpg",
  },
  {
    id: "9",
    name: "Kunal Mehta",
    studentId: "SM0932188",
    class: "6/A",
    points: 18,
    image: "https://randomuser.me/api/portraits/men/46.jpg",
  },
  {
    id: "10",
    name: "Ankita Roy",
    studentId: "SM0723155",
    class: "7/B",
    points: 11,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: "11",
    name: "Siddharth Rao",
    studentId: "SM0112107",
    class: "8/C",
    points: 9,
    image: "https://randomuser.me/api/portraits/men/47.jpg",
  },
  {
    id: "12",
    name: "Fatima Zafar",
    studentId: "SM0812113",
    class: "9/D",
    points: 15,
    image: "https://randomuser.me/api/portraits/women/45.jpg",
  },
  {
    id: "13",
    name: "Vivek Bansal",
    studentId: "SM0631125",
    class: "10/C",
    points: 24,
    image: "https://randomuser.me/api/portraits/men/48.jpg",
  },
  {
    id: "14",
    name: "Zoya Ahmed",
    studentId: "SM0922101",
    class: "11/A",
    points: 6,
    image: "https://randomuser.me/api/portraits/women/46.jpg",
  },
  {
    id: "15",
    name: "Harshit Tiwari",
    studentId: "SM0533201",
    class: "12/B",
    points: 17,
    image: "https://randomuser.me/api/portraits/men/49.jpg",
  },
]);


  const _this = {
    classesFilter,
    setClassesFilter,
    genderWaysFilter,
    setGenderWaysFilter,
    overViewCardData,
    setOverViewCardData,
    attendanceData,
    setAttendanceData,
    lineChartFilter,
    setLineChartFilter,
    absenteesData,
    setAbsenteesData,
    onleaveData,
    setOnleaveData,
    classWiseAttendanceData,
    setClassWiseAttendanceData,
    bestPerformers,
    setBestPerformers,
  };
  return <Body {..._this} />;
};

export default Dashboard;
